import type { LabelOption as Option } from '@atlassian/jira-issue-shared-types/src/common/types/labels-type.tsx';
import { MUTATION_GROUP } from './constants.tsx';
import type { LabelData, FieldValue, JiraLabelsFieldInput } from './types.tsx';

export const mapDataToLabelOptions = (data: LabelData): FieldValue =>
	data.map(
		({ name, color }): Option => ({
			value: name,
			label: name,
			...(color ? { color: color.colorKey } : {}),
		}),
	);

export const mutateLabelsFields = (
	selectedLabels: FieldValue,
	fieldId: string,
): JiraLabelsFieldInput => ({
	fieldId,
	labels: selectedLabels.map(({ value }) => ({ name: value })),
	mutationGroup: MUTATION_GROUP,
});
